import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { FaBars, FaTimes } from 'react-icons/fa';
import './HomeHeader.css';

const NAV_LINKS = [
  { to: '/#features',   label: 'Features' },
  { to: '/#how',        label: 'How it Works' },
  { to: '/#punter',     label: 'Punter+' },
  { to: '/#referral',   label: 'Refer & Earn' },
  { to: '/#testimonials', label: 'Reviews' },
];

const HomeHeader = () => {
  const { isAuthenticated } = useAuth();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Lock body scroll while the mobile menu is open
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  return (
    <>
      <header className={`home-header ${scrolled ? 'scrolled' : ''}`}>
        <div className="home-header-logo">
          <img src="/logo.png" alt="XPunters" />
          <span>XPunters</span>
        </div>

        <nav className="home-header-nav" aria-label="Main">
          {NAV_LINKS.map(({ to, label }) => (
            <a key={to} href={to}>{label}</a>
          ))}
        </nav>

        <div className="home-header-actions">
          {isAuthenticated ? (
            <Link to="/dashboard" className="btn btn-primary btn-sm">Dashboard</Link>
          ) : (
            <>
              <Link to="/login"    className="btn btn-secondary btn-sm">Login</Link>
              <Link to="/register" className="btn btn-primary btn-sm">Join Free</Link>
            </>
          )}
        </div>

        <button
          className="home-header-toggle"
          onClick={() => setOpen(!open)}
          type="button"
          aria-label="Toggle menu"
          aria-expanded={open}
        >
          {open ? <FaTimes /> : <FaBars />}
        </button>
      </header>

      {/* Mobile menu */}
      <div className={`home-mobile-menu ${open ? 'open' : ''}`}>
        <nav className="home-mobile-nav">
          {NAV_LINKS.map(({ to, label }) => (
            <a
              key={to}
              href={to}
              onClick={() => setOpen(false)}
            >
              {label}
            </a>
          ))}
        </nav>

        <div className="home-mobile-actions">
          {isAuthenticated ? (
            <Link to="/dashboard" className="btn btn-primary" onClick={() => setOpen(false)}>
              Dashboard
            </Link>
          ) : (
            <>
              <Link to="/login" className="btn btn-secondary" onClick={() => setOpen(false)}>
                Login
              </Link>
              <Link to="/register" className="btn btn-primary" onClick={() => setOpen(false)}>
                Join Free
              </Link>
            </>
          )}
        </div>
      </div>

      {open && (
        <div className="home-mobile-overlay" onClick={() => setOpen(false)} />
      )}
    </>
  );
};

export default HomeHeader;